export const REJECTED_CROSSCUTTING_REQUEST = "REJECTED_CROSSCUTTING_REQUEST";
export const REJECTED_CROSSCUTTING_SUCCESS = "REJECTED_CROSSCUTTING_SUCCESS";
export const REJECTED_CROSSCUTTING_FAILED = "REJECTED_CROSSCUTTING_FAILED";
